<template>
  <div class="dashboard-container">
    <div class="main-box">
      <!-- <img :src="img_welcome" alt=""> -->
      <span class="text">欢迎使用音像电子出版单位年度核验管理系统</span>
      <div v-if="userInfo.orgType == 2">
        <el-table :data="tableData" style="width: 100%" border>
          <el-table-column prop="type" label="出版单位类型" width="180"> </el-table-column>
          <el-table-column prop="sumNum" label="出版单位数量" width="180">
            <template slot-scope="scope">
              <el-icon name="sumNum"></el-icon>
              <span style="margin-left: 10px" @click="handTopage(scope.row.type, 99)">{{ scope.row.sumNum }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="uncommitNum" label="未提交数量">
            <template slot-scope="scope">
              <el-icon name="sumNum"></el-icon>
              <span style="margin-left: 10px" @click="handTopage(scope.row.type, 8)">{{ scope.row.uncommitNum }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="waitCheckNum" label="待审核数量">
            <template slot-scope="scope">
              <el-icon name="sumNum"></el-icon>
              <span style="margin-left: 10px" @click="handTopage(scope.row.type, 0)">{{ scope.row.waitCheckNum }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="checkNum" label="已审核数量">
            <template slot-scope="scope">
              <el-icon name="sumNum"></el-icon>
              <span style="margin-left: 10px" @click="handTopage(scope.row.type, 1)">{{ scope.row.checkNum }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- <div class="enText">Welcome to use the book publishing units yearly check online platform</div> -->
    </div>
    <!-- <div>
            <el-button type="primary" @click="down" size="mini">下载</el-button>
        </div> -->
  </div>
</template>

<script>
import img_welcome from "@/assets/images/welcome.png";
import { provinceStatistics } from "@/api/provinceRole/provinceRole";
// import { ExcelErrors } from '@/api/pressAsk';

export default {
  name: "dashboard",
  data() {
    return {
      img_welcome,
      list: [],
      downloadLoading: false,
      tableData: [],
      userInfo: {},
    };
  },
  methods: {
    getProvinceList: function () {
      provinceStatistics().then((response) => {
        // console.log('response=',JSON.stringify(response));
        this.tableData = response.provinceStatisticsList;
        this.userInfo = response.userInfo;

        for (const item of this.tableData) {
          if (item.type == 1) {
            item.type = "音像";
          } else if (item.type == 2) {
            item.type = "电子";
          } else if (item.type == 3) {
            item.type = "连续电子";
          }
        }
      });
    },
    //
    handTopage(type, key) {
      if (type == "音像") {
        this.$router.push({ path: "/province_role/audio_exam?key=" + key });
      } else if (type == "电子") {
        this.$router.push({ path: "/province_role/elect_exam?key=" + key });
      } else if (type == "连续电子") {
        this.$router.push({ path: "/province_role/successive_exam?key=" + key });
      }
    },
    // down(){
    //   this.downloadLoading = true
    //   import('@/views/components/excel/Export2Excel').then(excel => {
    //     const tHeader = ['id', 'code', 'errMsg', 'materialId', 'num','userId','content']
    //     const filterVal = ['id', 'code', 'errMsg', 'materialId', 'num','userId','content']
    //     const list = this.list
    //     const data = this.formatJson(filterVal, list)
    //     console.log(data);
    //     excel.export_json_to_excel({
    //       header: tHeader,
    //       data,
    //       filename: this.filename,
    //       autoWidth: this.autoWidth
    //     })
    //     this.downloadLoading = false
    //   })
    //
    // },
    // importExcel(){
    //
    // },
    // formatJson(filterVal, jsonData) {
    //     return jsonData.map(v => filterVal.map(j => {
    //       if (j === 'timestamp') {
    //         return parseTime(v[j])
    //       } else {
    //         return v[j]
    //       }
    //     }))
    // },
    // init(){
    //
    //     var dataIn = {};
    //     dataIn.code = "201";
    //     ExcelErrors(dataIn).then(response => {
    //         for(var i=0;i<100000;i++){
    //           this.list.push(response.payload.exportLogs[0]);
    //         }
    //         console.log(this.list);
    //     })
    // }
  },
  created: function () {
    // this.init();
    this.getProvinceList();
  },
};
</script>

<style media="screen">
.main-box {
  width: 900px;
  height: 60px;
  position: relative;
  text-align: center;
  line-height: 60px;
  font-size: 24px;
  margin: 0px auto;
  margin-top: 120px;
  color: #595959;

  /* position: absolute; */
}

.main-box span {
  display: block;
}

.el-table .cell {
  cursor: pointer;
}

.el-table {
  margin-top: 30px;
}

.el-table th > .cell {
  text-align: center;
}

.text {
  font-size: 36px;
  letter-spacing: 1.2px;
}

.enText {
  width: 900px;
  /* margin-left: -60px; */
  margin-top: -24px;
  font-size: 16px;
  /* font-weight: bold; */

  color: #aeaeae;
}

.main-box img {
  position: absolute;
  right: -9px;
  top: -45px;
}
</style>



// WEBPACK FOOTER //
// index.vue?75ecd60c